export default __webpack_public_path__ + "assets/3cc7b6de5c344f37219871c62921a780.jpg";